import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Box } from "@mui/system";
import FilterComponent from "../../../../../../../../ReusableFIlterComponent/FilterComponent";
import {
  setSelectedAdGroupForUnclassifiedST,
  setSelectedCampaignForUnclassifiedST,
  setSelectedKeywordForUnclassifiedST,
} from "../../../../../../../../../features/searchTermTabSlice";

export default function STUnclassifiedFilterItems({
  clearSelectedSearchTerm,
}: any) {
  const {
    stWithPerformanceUnClassified,
    selectedCampaignForUnclassifiedST,
    selectedAdGroupForUnclassifiedST,
    selectedKeywordForUnclassifiedST,
  } = useSelector((state: any) => state.searchTermTab);

  const dispatch = useDispatch();

  const [searchAdgroups, setSearchAdgroups] = useState("");
  const [searchCampaigns, setSearchCampaigns] = useState("");
  const [searchKeywords, setSearchKeywords] = useState("");
  const filterConfig = [
    {
      key: "CampaignForUnclassifiedST",
      name: "Campaign",
      label: "Select one or more Campaigns",
      searchTerm: searchCampaigns,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchCampaigns(e.target.value),
      selectedOption: selectedCampaignForUnclassifiedST,
      filterName: "campaign_name",
      data: stWithPerformanceUnClassified,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedCampaignForUnclassifiedST(updatedSelection)),
      count:
        selectedCampaignForUnclassifiedST &&
        selectedCampaignForUnclassifiedST.length,
      colorSelected:
        selectedCampaignForUnclassifiedST !== null &&
        selectedCampaignForUnclassifiedST.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "AdgroupForUnclassifiedST",
      name: "Adgroup",
      label: "Select one or more Adgroups",
      searchTerm: searchAdgroups,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchAdgroups(e.target.value),
      selectedOption: selectedAdGroupForUnclassifiedST,
      filterName: "adgroup_name",
      data: stWithPerformanceUnClassified,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedAdGroupForUnclassifiedST(updatedSelection)),
      count:
        selectedAdGroupForUnclassifiedST &&
        selectedAdGroupForUnclassifiedST.length,
      colorSelected:
        selectedAdGroupForUnclassifiedST !== null &&
        selectedAdGroupForUnclassifiedST.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "KeywordsForUnclassifiedST",
      name: "Keyword",
      label: "Select one or more Keywords",
      searchTerm: searchKeywords,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchKeywords(e.target.value),
      selectedOption: selectedKeywordForUnclassifiedST,
      filterName: "keyword_name",
      data: stWithPerformanceUnClassified,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedKeywordForUnclassifiedST(updatedSelection)),
      count:
        selectedKeywordForUnclassifiedST &&
        selectedKeywordForUnclassifiedST.length,
      colorSelected:
        selectedKeywordForUnclassifiedST !== null &&
        selectedKeywordForUnclassifiedST.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
  ];

  const clearFilters = () => {
    dispatch(setSelectedCampaignForUnclassifiedST([]));
    dispatch(setSelectedAdGroupForUnclassifiedST([]));
    dispatch(setSelectedKeywordForUnclassifiedST([]));
    clearSelectedSearchTerm(null);
    setSearchAdgroups("");
    setSearchCampaigns("");
    setSearchKeywords("");
  };

 
  return (
    <Box data-tracker="537" sx={{ position: "relative" }}>
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
      />
    </Box>
  );
}
